import { getConfigFor } from './helpers/getConfigFor';

export const origin = getConfigFor.hostEnv<string>({
	localhost: getConfigFor.project<string>({
		op: `http://localhost:${process.env.PORT || '4000'}`,
		bgov: `http://localhost:${process.env.PORT || '4020'}`,
	}),
	server: getConfigFor.environment<string>({
		local: getConfigFor.project<string>({
			op: `http://localhost`,
			bgov: `http://localhost`,
		}),
		tst: getConfigFor.project<string>({
			op: 'https://tst.ondernemersplein.overheid.nl',
			bgov: 'https://tst.business.gov.nl',
		}),
		acp: getConfigFor.project<string>({
			op: 'https://acp.ondernemersplein.overheid.nl',
			bgov: 'https://acp.business.gov.nl',
		}),
		staging: getConfigFor.project<string>({
			op: 'https://staging.ondernemersplein.overheid.nl',
			bgov: 'https://staging.business.gov.nl',
		}),
		prd: getConfigFor.project<string>({
			op: 'https://ondernemersplein.overheid.nl',
			bgov: 'https://business.gov.nl',
		}),
	}),
});

export const localOrigin = getConfigFor.project<string>({
	op: `http://localhost:${process.env.PORT || '4000'}`,
	bgov: `http://localhost:${process.env.PORT || '4020'}`,
});
